import type { FieldConfigOverride } from "../types";

export const CO_KYB_OVERRIDE: FieldConfigOverride = {
	id: "CO-any-kyb-v1",
	incorporationCountry: "CO",
	flowType: "KYB",
	version: "1.0.0",
	priority: 20,

	fieldOverrides: {
		entityType: {
			options: [
				{
					value: "SAS",
					label: { en: "Sociedad por Acciones Simplificada (SAS)" },
				},
				{ value: "SA", label: { en: "Sociedad Anónima (S.A.)" } },
				{
					value: "Ltda",
					label: { en: "Sociedad de Responsabilidad Limitada (Ltda.)" },
				},
				{ value: "Persona Natural", label: { en: "Persona Natural" } },
				{
					value: "Empresa Unipersonal",
					label: { en: "Empresa Unipersonal (E.U.)" },
				},
				{ value: "SNC", label: { en: "Sociedad en Nombre Colectivo" } },
			],
		},
		registrationNumber: {
			label: { en: "NIT (Número de Identificación Tributaria)" },
			helpText: { en: "The NIT assigned by the DIAN. Format: XXXXXXXXX-X" },
			validationRules: [
				{
					type: "regex",
					value: "^\\d{9}-\\d$",
					message: "NIT must be in format XXXXXXXXX-X",
				},
			],
		},
		sanctionsScreening: {
			helpText: {
				en: "Colombian entities must screen against UIAF lists in addition to international sanctions lists.",
			},
		},
	},

	additionalFields: [
		{
			fieldId: "rutDocument",
			step: 1,
			section: "company_basics",
			order: 66,
			label: { en: "RUT Document (Registro Único Tributario)" },
			type: "file",
			visible: true,
			required: true,
			validationRules: [
				{
					type: "required",
					message: "RUT document is required for Colombian entities",
				},
			],
			helpText: { en: "Upload the current RUT certificate issued by DIAN." },
		},
	],

	// Colombia SARLAFT regulation: UBO disclosure at 5%
	uboDisclosureThreshold: 5,
	ownershipDisclosureThreshold: 5,
};
